const Redirect=({url}:{url:string}):null =>{
    // 👇️ using window.location.href 👇️
    window.location.replace(url);
    return null;
  }
  export default Redirect